module.exports = __webpack_public_path__ + "static/media/kia-vial.cf7729e7.svg";